import Image from 'next/image';

import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { FlexColumn } from 'styles/layouts';

import { NAVBAR_QUERIES } from '../utils';

export const CardWrapper = styled(FlexColumn)`
  gap: 12px;
  width: 100%;
  height: 100%;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 12px;
  border-radius: ${themeStyle.radiusMedium};
  border: 1px solid ${themeStyle.varInkSuperLight};

  ${QUERIES.largeTabletAndUp} {
    padding: 16px;
  }
  cursor: pointer;

  &:hover {
    background: ${themeStyle.varInkSuperLight};
  }
`;

export const ImageWrapper = styled.div<{ isMobile: boolean }>`
  position: relative;
  display: block;
  min-height: ${({ isMobile }) => (isMobile ? '180px' : '177px')};
  min-width: 100%;
`;

export const CardImage = styled(Image)`
  width: 100%;
  max-height: 177px;
  flex-grow: 1;
  object-fit: cover;
  border-radius: ${themeStyle.radiusMedium};
`;

export const CardBody = styled(FlexColumn)`
  align-items: flex-start;
  white-space: break-spaces;

  gap: 8px;

  ${NAVBAR_QUERIES.headerTabletMinWidth} {
    gap: 6px;
  }

  ${QUERIES.laptopAndUp} {
    gap: 4px;
  }
`;
